import React from "react";
export const CheckboxInput = (props) => {
    return (React.createElement("input", { type: "checkbox", name: props.name, className: props.className, checked: props.value, onChange: (event) => props.onChange(event.target.checked) }));
};
export const TextInput = (props) => {
    return (React.createElement("input", { type: props.type ?? "text", name: props.name, className: props.className, placeholder: props.placeholder, value: props.value ?? "", onChange: (event) => props.onChange(event.target.value) }));
};
export const Select = (props) => {
    const { name, optgroups, value } = props;
    return (React.createElement("select", { key: name, name: name, className: props.className, value: value ?? "", onChange: (event) => props.onChange(event.target.value) }, optgroups.map((optgroup) => {
        const optgroupValue = (optgroup[1][0].value ?? "").toString();
        return (React.createElement("option", { key: optgroupValue, value: optgroupValue }, optgroup[1][0].label));
    })));
};
export const Textarea = (props) => {
    return (React.createElement("textarea", { name: props.name, className: props.className, value: props.value ?? "", onChange: (event) => props.onChange(event.target.value) }));
};
//# sourceMappingURL=widgets.js.map